import React from 'react'
import ProductSlider from './ProductSlider';
import Arrow from '../../images/arrow.png';
function Product({ product, selected, type_id, setType }) {

    const setTypeId = (e, typeId, productId) => {
        e.preventDefault();
        setType(typeId, productId);
        let $timeout;
        $timeout = setTimeout(() => {
            clearTimeout($timeout);
            var btn = document.getElementById('submitForm');
            if (btn) {
                btn.scrollIntoView({ behavior: 'smooth' });
            }
        }, 150);
    }
    var description = [];
    var bestfits = [];
    var sentances = [];
    if (product.sentances) {
        sentances = product.sentances.split(';');
    }
    if (product.description) {
        bestfits = product.description.split(';');
    }
    if (product.features) {
        description = product.features.split(';');
    }

    const { types } = product;
    return (
        <div className={selected === product.id ? 'prod selected ' : 'prod'} id={'prod_' + product.id}>
            <div className="card">
                <div className="inner-card">
                    <div className="top-card">
                        <ProductSlider product={product.id} />
                    </div>
                    <div className="middle-card d-flex flex-column align-items-center">
                        <h5 className="prod_name">{product.name}</h5>
                        <div className="d-flex align-items-end">
                            <div className="process d-flex align-items-end">
                                <span>+</span>
                                <span>0</span>
                                <span>%</span>
                                <span>Credit Card<br />Processing</span>
                            </div>
                        </div>
                        {product.icons ?
                            <>
                                <div className="cc-icons-div">
                                    <div className="icon-list">
                                        {product.icons.map((icon, i) => {
                                            return <div className="icon-item" key={i} style={{ backgroundImage: `url("${icon}")` }}></div>;
                                        })}
                                    </div>

                                </div>
                            </>
                            : ''}
                    </div>
                    <div className="bottom-card">
                        <div className="row justify-content-center">
                            {sentances.length > 0 ?
                                <div className="col-11">
                                    {sentances.map((sentance, i) => {
                                        return sentance != '' ? <h3 className="prod-sentance" key={i}>{sentance}</h3> : ''
                                    })}

                                </div>
                                : ''}
                        </div>
                        <div className="row">
                            {description.length > 0 ?
                                <div className="col-12">
                                    <div className="description">
                                        <ul className="description_text">
                                            {description.map((feature, i) => {
                                                return <li key={i}>
                                                    {/* <i className="fa fa-check-circle" style={{ color: '#87d601' }}></i>   */}
                                                    {/* <img src="{{Arrow}}" className="arrow" alt="" /> */}
                                                    {feature}
                                                </li>
                                            })}
                                        </ul>
                                    </div>
                                </div>
                                : ''
                            }

                        </div>
                        <div className="row justify-content-between">
                            {bestfits.length > 0 ?
                                <div className="col-xl-8 col-md-7 ">
                                    <div className="bestfits">
                                        <h6 className="card-title">Best fits for</h6>
                                        <ul className="list-unstyled">
                                            {bestfits.map((feature, i) => {
                                                return <li key={i}><i className="fa fa-check" style={{ color: '#87d601' }}></i> {feature}</li>
                                            })}
                                        </ul>

                                    </div>
                                </div>
                                : ''
                            }
                            <div className={bestfits.length > 0 ? "col-xl-4 col-md-5 " : "col-12"}>
                                <div className="price-wrap pricing">
                                    {types.map((type) => {
                                        let $regularPrice = type.price.toFixed(2).toString();
                                        let $discountPrice = type.discount_price ? type.discount_price.toFixed(2).toString() : null;
                                        switch (type.name) {
                                            case 'free':
                                                return (
                                                    <div className="pay-item" key={type.id}>

                                                        <p className="tag">Get it</p>
                                                        <div className="price-block">
                                                            <p className="free mb-0"><span>Free</span></p>
                                                        </div>
                                                    </div>
                                                );
                                            case 'lease':
                                                return (
                                                    <div className="pay-item" key={type.id}>
                                                        <p className="tag">Lease for</p>
                                                        {$discountPrice ?
                                                            <div className="price-block">
                                                                <p className="price mb-3">${$discountPrice.split('.')[0]}<sub>.{$discountPrice.split('.')[1]}/mo</sub></p>
                                                                <p className="free discount-price free-price">
                                                                    <del>${$regularPrice}</del><sub>/mo</sub></p>
                                                            </div>
                                                            :
                                                            <div className="price-block">
                                                                <p className="price mb-3">
                                                                    ${$regularPrice.split('.')[0]}<sub>.{$regularPrice.split('.')[1]}</sub><sub>/mo</sub>
                                                                </p>
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            case 'buy':
                                                return (
                                                    <div className="pay-item" key={type.id}>
                                                        <p className="tag">Buy for</p>
                                                        {$discountPrice ?
                                                            <div className="price-block">
                                                                <p className="price mb-3">${$discountPrice.split('.')[0]}<sub>.{$discountPrice.split('.')[1]}</sub></p>
                                                                <p className="free discount-price free-price">
                                                                    <del>${$regularPrice}</del></p>
                                                            </div>
                                                            :
                                                            <div className="price-block">

                                                                <p className="price mb-3">${$regularPrice.split('.')[0]}<sub>.{$regularPrice.split('.')[1]}</sub></p>
                                                            </div>

                                                        }
                                                    </div>
                                                )
                                            default:

                                        }
                                        return null
                                    })}
                                </div>
                            </div>
                            {/* {selected === product.id ? */}

                            <div className="col-12 btns">
                                {types.map((type) => {
                                    switch (type.name) {
                                        case 'free':
                                            return (
                                                <button key={type.id} className={type_id === type.id ? 'free-button active' : 'free-button'} onClick={(e) => setTypeId(e, type.id, product.id)} >Get it Now</button>
                                            );
                                        case 'lease':
                                            return (
                                                <button key={type.id} className={type_id === type.id ? 'lease active' : 'lease'} onClick={(e) => setTypeId(e, type.id, product.id)}>Lease</button>
                                            );
                                        case 'buy':
                                            return (
                                                <button key={type.id} className={type_id === type.id ? 'purchase active' : 'purchase'} onClick={(e) => setTypeId(e, type.id, product.id)}>Buy</button>
                                            );
                                        default:
                                    }
                                    return null
                                })}

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Product
